import { defineComponent as e, computed as t, resolveComponent as n, createBlock as c, openBlock as l, normalizeStyle as a, withCtx as s, renderSlot as i } from "vue";
import p from "./Button-CkAyItqk.js";
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const y = e({
  components: { TButton: p },
  props: {
    iconSize: {
      type: String,
      default: () => "sm"
    },
    color: {
      type: String,
      default: () => "tertiary_gray"
    }
  },
  setup(o) {
    return {
      c: t(() => o.color === "tertiary_gray" ? "tertiary" : o.color),
      s: t(() => o.color === "tertiary_gray" ? "--color: var(--tw-color-gray-400); --color-hover: var(--tw-color-gray-400);" : "")
    };
  }
});
function m(o, f, d, _, g, B) {
  const r = n("TButton");
  return l(), c(r, {
    color: o.c,
    style: a(o.s),
    round: "",
    "icon-only": "",
    size: o.$props.iconSize
  }, {
    default: s(() => [
      i(o.$slots, "default")
    ]),
    _: 3
  }, 8, ["color", "style", "size"]);
}
const v = /* @__PURE__ */ u(y, [["render", m]]);
export {
  v as default
};
//# sourceMappingURL=ButtonIcon-D4squ00_.js.map
